import Vue from 'vue'
import ja from 'vee-validate/dist/locale/ja.json'
import { ValidationProvider, ValidationObserver, localize, extend } from 'vee-validate'
import * as rules from 'vee-validate/dist/rules'

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)

Object.keys(rules).forEach((key) => {
  const value: any = rules
  extend(key, value[key])
})

localize('ja', ja)

extend('no_at_sign', {
  validate(value: unknown) {
    const str = String(value ?? '')
    return !str.includes('@')
  },
  message: '名前にメールアドレスは使用できません。'
})

extend('total_size', {
  params: ['limit'],
  validate(value: File[], args: any) {
    const total = value.reduce((sum, file) => sum + file.size, 0)
    return total <= args.limit * 1000 * 1000
  },
  message: '合計ファイルサイズは {limit} MB以下である必要があります。'
})
